jQuery(document).ready(function($) {
    (function initAppMainOffset() {
        var shell = document.querySelector('.site-header-shell');
        var appMain = document.getElementById('AppMain');
        if (!shell || !appMain) return;

        function updateAppMainOffset() {
            var headerHeight = shell.offsetHeight + 'px';
            appMain.style.paddingTop = headerHeight;
            document.documentElement.style.setProperty('--site-header-height', headerHeight);
        }

        updateAppMainOffset();

        if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(updateAppMainOffset).observe(shell);
        } else {
            $(window).on('resize', updateAppMainOffset);
        }
    })();

    (function initSiteSearch() {
        var $searchToggle = $('.site-header__action--search');
        var $search = $('#site-search');
        var $overlay = $('.site-search-overlay');
        var $input = $('#site-search-input');
        var $results = $('.site-search__results');
        var $close = $('.site-search__close');
        var debounceTimer = null;
        var activeRequest = null;

        if (!$searchToggle.length || !$search.length || typeof devignSearch === 'undefined') {
            return;
        }

        function openSearch() {
            $('body').addClass('search-open');
            $search.attr('aria-hidden', 'false').addClass('is-open');
            $overlay.attr('aria-hidden', 'false').addClass('is-open');
            $searchToggle.attr('aria-expanded', 'true');
            window.setTimeout(function () {
                $input.trigger('focus');
            }, 100);
        }

        function closeSearch() {
            $('body').removeClass('search-open');
            $search.attr('aria-hidden', 'true').removeClass('is-open');
            $overlay.attr('aria-hidden', 'true').removeClass('is-open');
            $searchToggle.attr('aria-expanded', 'false');
            $input.val('');
            $results.empty();

            if (activeRequest) {
                activeRequest.abort();
                activeRequest = null;
            }
        }

        function escapeHtml(value) {
            return $('<div>').text(value || '').html();
        }

        function renderResults(data) {
            var categories = data.categories || [];
            var products = data.products || [];
            var html = '';

            if (!categories.length && !products.length) {
                $results.html('<p class="site-search__status">No results found.</p>');
                return;
            }

            if (categories.length) {
                html += '<div class="site-search__group">';
                html += '<p class="site-search__group-title">Categories</p>';
                html += '<ul class="site-search__list">';

                categories.forEach(function (item) {
                    html += '<li class="site-search__item site-search__item--category">';
                    html += '<a href="' + escapeHtml(item.url) + '" class="site-search__link">';
                    html += '<span class="site-search__thumb">';
                    if (item.image) {
                        html += '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">';
                    }
                    html += '</span>';
                    html += '<span class="site-search__meta">';
                    html += '<span class="site-search__title">' + escapeHtml(item.title) + '</span>';
                    html += '<span class="site-search__label">Category</span>';
                    html += '</span>';
                    html += '</a></li>';
                });

                html += '</ul></div>';
            }

            if (products.length) {
                html += '<div class="site-search__group">';
                html += '<p class="site-search__group-title">Products</p>';
                html += '<ul class="site-search__list">';

                products.forEach(function (item) {
                    html += '<li class="site-search__item site-search__item--product">';
                    html += '<a href="' + escapeHtml(item.url) + '" class="site-search__link">';
                    html += '<span class="site-search__thumb">';
                    if (item.image) {
                        html += '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">';
                    }
                    html += '</span>';
                    html += '<span class="site-search__meta">';
                    html += '<span class="site-search__title">' + escapeHtml(item.title) + '</span>';
                    html += '<span class="site-search__details">';
                    if (item.category) {
                        html += '<span class="site-search__label">' + escapeHtml(item.category) + '</span>';
                    }
                    if (item.price) {
                        html += '<span class="site-search__price">';
                        if (item.variable) {
                            html += 'from ';
                        }
                        html += escapeHtml(item.price);
                        html += '</span>';
                    }
                    html += '</span>';
                    html += '</span>';
                    html += '</a></li>';
                });

                html += '</ul></div>';
            }

            $results.html(html);
        }

        function performSearch(term) {
            if (activeRequest) {
                activeRequest.abort();
            }

            $results.html('<p class="site-search__status">Searching…</p>');

            activeRequest = $.ajax({
                url: devignSearch.ajaxUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'devign_product_search',
                    nonce: devignSearch.nonce,
                    term: term
                }
            }).done(function (response) {
                activeRequest = null;

                if (!response || !response.success) {
                    $results.html('<p class="site-search__status">Something went wrong. Please try again.</p>');
                    return;
                }

                renderResults(response.data || {});
            }).fail(function (_xhr, status) {
                if (status !== 'abort') {
                    activeRequest = null;
                    $results.html('<p class="site-search__status">Something went wrong. Please try again.</p>');
                }
            });
        }

        $searchToggle.on('click', function (e) {
            e.preventDefault();

            if ($search.hasClass('is-open')) {
                closeSearch();
            } else {
                openSearch();
            }
        });

        $close.on('click', closeSearch);
        $overlay.on('click', closeSearch);

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && $search.hasClass('is-open')) {
                closeSearch();
            }
        });

        $input.on('input', function () {
            var term = $.trim($input.val());

            clearTimeout(debounceTimer);

            if (term.length < 2) {
                $results.empty();

                if (activeRequest) {
                    activeRequest.abort();
                    activeRequest = null;
                }

                return;
            }

            debounceTimer = window.setTimeout(function () {
                performSearch(term);
            }, 300);
        });
    })();

    // let bp = BiggerPicture({
    //     target: document.body,
    // });

    // $('.trigger-carousel-lightbox').on('click', function(e) {
    //     bp.open({
    //         items: document.querySelectorAll('.gallery-carousel .glide__slide:not(.glide__slide--clone) img'),
    //         el: e.currentTarget
    //     })
    // });

    // $('.trigger-lightbox-white').on('click', function() {
    //     bp.open({
    //         items: $(this).parent().find('img'),
    //         onOpen: (container) => container.classList.add('white'),
    //     });
    // });

    $(window).on('scroll', function(){
        if($(window).scrollTop() > 50) {
            $('.site-header').addClass('scrolled');
        } else {
            $('.site-header').removeClass('scrolled');
        }
    });

    $('.menutoggle').on('click', function(){
        $(this).toggleClass('open');
        $('.site-header__nav').toggleClass('open');
        $('body').toggleClass('nav-open');
    });

    $('.menu-item-has-children > a').on('click', function(e){
        if($(window).width() < 1200) {
            e.preventDefault();
            $(this).parent().toggleClass('open');
            $(this).parent().find('.sub-menu').slideToggle();
        }
    });

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
        else var expires = "";               
    
        document.cookie = name + "=" + value + expires + "; path=/";
    }
    
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    
    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

    $('.hero__featured-product').on('click', function(e){
        e.preventDefault();
        if($(this).hasClass('active')) {
            window.location.href = $(this).attr('href');
        } else {
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
        }
    });

    // Single product: product gallery
    if ($('body.single-product').length) {
        (function initProductGallery() {
            var gallery = document.querySelector('.woocommerce-product-gallery');
            if (!gallery) return;

            var wrapper = gallery.querySelector('.woocommerce-product-gallery__wrapper');
            if (!wrapper) return;

            var galleryImages = wrapper.querySelectorAll(':scope > .woocommerce-product-gallery__image');
            var mainWrap = galleryImages[0];
            if (!mainWrap) return;

            var thumbEls = Array.prototype.slice.call(galleryImages, 1);
            var thumbsContainer = wrapper.querySelector('.product-gallery-thumbs');

            if (thumbEls.length && !thumbsContainer) {
                thumbsContainer = document.createElement('div');
                thumbsContainer.className = 'product-gallery-thumbs';
                thumbEls.forEach(function (el) {
                    thumbsContainer.appendChild(el);
                });
                wrapper.appendChild(thumbsContainer);
            }

            var thumbnails = thumbsContainer
                ? thumbsContainer.querySelectorAll('.woocommerce-product-gallery__image')
                : [];

            var bpInstance = null;

            function getBp() {
                if (typeof BiggerPicture === 'undefined') {
                    return null;
                }

                if (!bpInstance) {
                    bpInstance = BiggerPicture({ target: document.body });
                }

                return bpInstance;
            }

            function getUniqueGalleryItems() {
                var seen = new Set();
                var items = [];

                wrapper.querySelectorAll('.woocommerce-product-gallery__image').forEach(function (item) {
                    var img = item.querySelector('img');
                    var link = item.querySelector('a');
                    if (!img) {
                        return;
                    }

                    var href = (link && link.getAttribute('href')) || img.getAttribute('data-large_image') || img.src;
                    if (!href || seen.has(href)) {
                        return;
                    }

                    seen.add(href);
                    items.push({
                        element: img,
                        img: href,
                        alt: img.getAttribute('alt') || '',
                        width: img.getAttribute('data-large_image_width') || img.naturalWidth || 1920,
                        height: img.getAttribute('data-large_image_height') || img.naturalHeight || 1080,
                    });
                });

                return items;
            }

            function openLightbox(e) {
                e.preventDefault();
                e.stopPropagation();

                var bp = getBp();
                if (!bp) {
                    return false;
                }

                var items = getUniqueGalleryItems();
                if (!items.length) {
                    return false;
                }

                var activeImg = mainWrap.querySelector('img');

                bp.open({
                    items: items,
                    el: activeImg || e.currentTarget,
                });

                return false;
            }

            var mainLink = mainWrap.querySelector('a');
            if (mainLink) {
                mainLink.addEventListener('click', openLightbox);
            }

            if (!thumbsContainer) {
                return;
            }

            thumbsContainer.addEventListener('click', function (e) {
                var thumb = e.target.closest('.woocommerce-product-gallery__image');
                if (!thumb) {
                    return;
                }

                e.preventDefault();

                var a = thumb.querySelector('a');
                var img = thumb.querySelector('img');
                if (!a || !img) {
                    return;
                }

                var fullSrc = a.getAttribute('href') || img.getAttribute('data-large_image') || img.src;
                if (!fullSrc) {
                    return;
                }

                var mainImg = mainWrap.querySelector('img');
                var mainA = mainWrap.querySelector('a');
                if (mainImg) {
                    mainImg.src = fullSrc;
                    mainImg.removeAttribute('srcset');
                    mainImg.removeAttribute('sizes');
                    if (img.getAttribute('data-large_image')) {
                        mainImg.setAttribute('data-large_image', fullSrc);
                    }
                }
                if (mainA) {
                    mainA.setAttribute('href', fullSrc);
                }

                thumbnails.forEach(function (t) {
                    t.classList.remove('product-gallery--active');
                });
                thumb.classList.add('product-gallery--active');
            });

            if (thumbnails.length) {
                thumbnails[0].classList.add('product-gallery--active');
            }
        })();

        (function initProductSummarySticky() {
            var grid = document.querySelector('.single-product-layout__grid');
            var summary = document.querySelector('.single-product-layout__summary');
            if (!grid || !summary) return;

            var mq = window.matchMedia('(min-width: 1024px)');
            var ticking = false;

            function getTopOffset() {
                var shell = document.querySelector('.site-header-shell');
                return (shell ? shell.offsetHeight : 120) + 24;
            }

            function updateSticky() {
                ticking = false;

                if (!mq.matches) {
                    summary.style.transform = '';
                    summary.classList.remove('is-summary-sticky');
                    return;
                }

                var topOffset = getTopOffset();
                var gridTop = grid.getBoundingClientRect().top + window.scrollY;
                var stickyStart = gridTop - topOffset;
                var scrollPast = window.scrollY - stickyStart;
                var maxTranslate = Math.max(0, grid.offsetHeight - summary.offsetHeight);
                var translateY = Math.max(0, Math.min(scrollPast, maxTranslate));

                if (translateY > 0) {
                    summary.style.transform = 'translate3d(0, ' + translateY + 'px, 0)';
                    summary.classList.add('is-summary-sticky');
                } else {
                    summary.style.transform = '';
                    summary.classList.remove('is-summary-sticky');
                }
            }

            function requestUpdate() {
                if (!ticking) {
                    ticking = true;
                    window.requestAnimationFrame(updateSticky);
                }
            }

            window.addEventListener('scroll', requestUpdate, { passive: true });
            window.addEventListener('resize', requestUpdate);
            mq.addEventListener('change', requestUpdate);

            if (typeof ResizeObserver !== 'undefined') {
                var observer = new ResizeObserver(requestUpdate);
                observer.observe(grid);
                observer.observe(summary);
            }

            requestUpdate();
        })();

        (function initVariableProductCartPrice() {
            function updateSaleBadge($button, regularPrice, salePrice) {
                var $badge = $button.find('.single-product-buy-now__badge');
                var regular = parseFloat(regularPrice);
                var sale = parseFloat(salePrice);
                var percent = 0;

                if (!isNaN(regular) && !isNaN(sale) && regular > 0 && sale > 0 && sale < regular) {
                    percent = Math.round(((regular - sale) / regular) * 100);
                }

                if (percent > 0) {
                    if (!$badge.length) {
                        $button.append('<span class="single-product-buy-now__badge">Save ' + percent + '%</span>');
                    } else {
                        $badge.text('Save ' + percent + '%');
                    }
                } else if ($badge.length) {
                    $badge.remove();
                }
            }

            function keepQuantityVisible($form) {
                $form.find('.single-product-cart-row__quantity .quantity input.qty').each(function () {
                    this.type = 'number';
                    this.style.setProperty('display', 'block', 'important');
                    this.style.setProperty('visibility', 'visible', 'important');
                    this.style.setProperty('opacity', '1', 'important');
                });

                $form.find('.single-product-cart-row__quantity .quantity').each(function () {
                    this.style.setProperty('display', 'block', 'important');
                    this.style.setProperty('visibility', 'visible', 'important');
                    this.style.setProperty('opacity', '1', 'important');
                });
            }

            $('.variations_form.cart').each(function () {
                var $form = $(this);

                keepQuantityVisible($form);

                $form.on('found_variation.wc-variation-form show_variation hide_variation reset_data woocommerce_update_variation_values', function () {
                    window.requestAnimationFrame(function () {
                        keepQuantityVisible($form);
                    });
                });

                $form.on('show_variation', function (event, variation) {
                    $form.find('.woocommerce-variation-add-to-cart .single-product-cart-price').html(variation.price_html || '');
                    updateSaleBadge(
                        $form.find('.single_add_to_cart_button'),
                        variation.display_regular_price,
                        variation.display_price
                    );
                    keepQuantityVisible($form);
                });

                $form.on('hide_variation reset_data', function () {
                    $form.find('.woocommerce-variation-add-to-cart .single-product-cart-price').empty();
                    $form.find('.single_add_to_cart_button .single-product-buy-now__badge').remove();
                    keepQuantityVisible($form);
                });
            });
        })();
    }

    // Single product: apply product colour to brand elements
    // Primary: hex from product meta (#colour-override). Fallback: extract from product image.
    if ($('body.single-product').length) {
        (function applyProductBrandColour() {
            var hex = null;
            var el = document.getElementById('colour-override');
            if (el && el.textContent) {
                hex = el.textContent.trim().replace(/^#/, '');
                if (/^[0-9A-Fa-f]{6}$/.test(hex)) {
                    hex = '#' + hex;
                } else {
                    hex = null;
                }
            }
            if (!hex) {
                var img = document.querySelector('.single-product .woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image img, .single-product .wp-post-image');
                if (img && img.complete && img.naturalWidth) {
                    hex = getDominantColorFromImage(img);
                    if (hex) {
                        hex = vividifyHex(hex, 1.25, 1.15);
                    }
                }
            }
            if (!hex) return;
            var style = document.getElementById('product-brand-colour-style');
            if (!style) {
                style = document.createElement('style');
                style.id = 'product-brand-colour-style';
                document.head.appendChild(style);
            }
            style.textContent =
                '#logo svg .st1 { fill: ' + hex + ' !important; stroke: ' + hex + ' !important; }' +
                '.single-product .ph-fill.ph-star { color: ' + hex + '; fill: ' + hex + '; }' +
                '.single-product #review_form .form-submit input[type="submit"], .single-product #review_form .form-submit button[type="submit"] { background-color: ' + hex + ' !important; }';
            var logoSt1 = document.querySelectorAll('#logo svg .st1');
            for (var i = 0; i < logoSt1.length; i++) {
                logoSt1[i].style.setProperty('fill', hex, 'important');
                logoSt1[i].style.setProperty('stroke', hex, 'important');
            }
        })();
        function vividifyHex(hex, satBoost, lightBoost) {
            var m = hex.slice(1).match(/.{2}/g);
            if (!m) return hex;
            var r = parseInt(m[0], 16) / 255, g = parseInt(m[1], 16) / 255, b = parseInt(m[2], 16) / 255;
            var max = Math.max(r, g, b), min = Math.min(r, g, b);
            var h, s, l = (max + min) / 2;
            if (max === min) { h = s = 0; } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch (max) {
                    case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                    case g: h = (b - r) / d + 2; break;
                    default: h = (r - g) / d + 4;
                }
                h /= 6;
            }
            s = Math.min(1, s * (satBoost || 1.25));
            l = Math.min(1, l * (lightBoost || 1.15));
            if (s === 0) { r = g = b = l; } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return '#' + [r, g, b].map(function (x) { return ('0' + Math.round(x * 255).toString(16)).slice(-2); }).join('');
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function getDominantColorFromImage(img) {
            try {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                var size = 64;
                canvas.width = size;
                canvas.height = size;
                ctx.drawImage(img, 0, 0, size, size);
                var data = ctx.getImageData(0, 0, size, size).data;
                var candidates = [];
                // rgb(53,57,68) - product/bottle base colour to ignore
                var ignoreR = 53, ignoreG = 57, ignoreB = 68, ignoreDistSq = 900;
                for (var i = 0; i < data.length; i += 4) {
                    var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
                    if (a < 128) continue;
                    if (r > 245 && g > 245 && b > 245) continue;
                    if (r < 15 && g < 15 && b < 15) continue;
                    var dr = r - ignoreR, dg = g - ignoreG, db = b - ignoreB;
                    if (dr * dr + dg * dg + db * db < ignoreDistSq) continue;
                    var sat = Math.max(r, g, b) - Math.min(r, g, b);
                    var luma = (r * 299 + g * 587 + b * 114) / 1000;
                    if (luma < 30 || luma > 240) continue;
                    candidates.push({ r: r, g: g, b: b, sat: sat });
                }
                if (candidates.length === 0) return null;
                candidates.sort(function (a, b) { return b.sat - a.sat; });
                var top = Math.max(1, Math.floor(candidates.length * 0.2));
                var sum = [0, 0, 0];
                for (var j = 0; j < top; j++) {
                    sum[0] += candidates[j].r;
                    sum[1] += candidates[j].g;
                    sum[2] += candidates[j].b;
                }
                var r = Math.round(sum[0] / top);
                var g = Math.round(sum[1] / top);
                var b = Math.round(sum[2] / top);
                return '#' + [r, g, b].map(function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
            } catch (e) {
                return null;
            }
        }
    }

    // Product carousel
    $('.product-carousel__slider').each(function () {
        var $slider = $(this);
        var $root = $slider.closest('.product-carousel');
        var glideInstance = null;

        if (typeof Glide !== 'undefined') {
            glideInstance = new Glide(this, {
                type: 'carousel',
                startAt: 0,
                perView: 4,
                gap: 20,
                bound: true,
                breakpoints: {
                    1200: { perView: 3 },
                    767: { perView: 2 },
                    420: { perView: 1 }
                }
            });

            glideInstance.on('run.after', function () {
                glideInstance.update();
            });

            glideInstance.mount();
        }

        function applyFilter(categoryId) {
            var $slides = $slider.find('.glide__slide');

            $slides.each(function () {
                var $slide = $(this);
                var $card = $slide.find('.product-card');
                var ids = ($card.data('category-ids') || '').toString().split(',').filter(Boolean);
                var show = categoryId === 'all' || ids.indexOf(String(categoryId)) !== -1;

                $slide.toggleClass('is-hidden', !show);
            });

            if (glideInstance) {
                glideInstance.update({ startAt: 0 });
            }
        }

        $root.find('.product-carousel__filter').on('click', function () {
            var categoryId = $(this).data('category').toString();

            $root.find('.product-carousel__filter').removeClass('is-active');
            $(this).addClass('is-active');
            applyFilter(categoryId);
        });

        $root.find('.product-carousel__arrow--prev').on('click', function () {
            if (glideInstance) glideInstance.go('<');
        });

        $root.find('.product-carousel__arrow--next').on('click', function () {
            if (glideInstance) glideInstance.go('>');
        });
    });

    // Reels carousel — simple Swiper: centered quintet, CSS scales, native loop
    $('.reels-carousel__carousel').each(function () {
        var $carousel = $(this);
        var $slider = $carousel.find('.reels-carousel__slider');
        var $wrapper = $slider.find('.swiper-wrapper');
        var originalCount = $wrapper.children('.swiper-slide').length;

        if (originalCount === 0 || typeof Swiper === 'undefined') {
            return;
        }

        // One duplicate set gives Swiper enough slides for stable loop + quintet layout.
        if (originalCount < 8) {
            $wrapper.children('.swiper-slide').clone(true).appendTo($wrapper);
        }

        var startIndex = originalCount + Math.floor(originalCount / 2);
        var slideData = [];

        $wrapper.children('.swiper-slide').slice(0, originalCount).each(function () {
            slideData.push({
                poster: $(this).attr('data-poster') || '',
                videoUrl: $(this).attr('data-video-url') || '',
                videoMime: $(this).attr('data-video-mime') || 'video/mp4',
            });
        });

        function getSlideDataFromDom($slide) {
            return {
                poster: $slide.attr('data-poster') || '',
                videoUrl: $slide.attr('data-video-url') || '',
                videoMime: $slide.attr('data-video-mime') || 'video/mp4',
            };
        }

        function getActiveSlideData(swiper, $activeSlide) {
            var dataIndex = swiper.realIndex;

            if (typeof dataIndex !== 'number' || dataIndex < 0 || dataIndex >= slideData.length) {
                dataIndex = parseInt($activeSlide.attr('data-reels-index'), 10);

                if (isNaN(dataIndex)) {
                    dataIndex = 0;
                }
            }

            var data = slideData[dataIndex];

            if (!data || !data.videoUrl) {
                data = getSlideDataFromDom($activeSlide);
            }

            return data;
        }

        function resetSlideMedia($slide) {
            var $media = $slide.find('.reels-carousel__media');
            var $poster = $media.find('.reels-carousel__poster');
            var $video = $media.find('.reels-carousel__player');

            if ($video.length) {
                var el = $video.get(0);
                if (el) {
                    el.pause();
                    el.removeAttribute('src');
                    el.load();
                }
                $video.remove();
            }

            $poster.show();
        }

        function playActiveVideo(swiper) {
            var $activeSlide = $(swiper.el).find('.swiper-slide-active').first();

            $(swiper.el).find('.swiper-slide').each(function () {
                var $slide = $(this);

                if (!$slide.is($activeSlide)) {
                    resetSlideMedia($slide);
                }
            });

            if (!$activeSlide.length) {
                return;
            }

            var data = getActiveSlideData(swiper, $activeSlide);

            if (!data.videoUrl) {
                return;
            }

            var $media = $activeSlide.find('.reels-carousel__media');
            var $poster = $media.find('.reels-carousel__poster');

            $media.find('.reels-carousel__player').remove();

            var $video = $('<video class="reels-carousel__player" autoplay muted playsinline loop></video>');

            $video.attr('poster', data.poster);
            $video.append($('<source>').attr('src', data.videoUrl).attr('type', data.videoMime));
            $media.append($video);

            var el = $video.get(0);
            if (el) {
                el.addEventListener('loadeddata', function () {
                    $poster.hide();
                }, { once: true });
                el.play().catch(function () {});
            }
        }

        new Swiper($slider[0], {
            loop: originalCount >= 3,
            loopedSlides: originalCount,
            centeredSlides: true,
            slidesPerView: 'auto',
            initialSlide: startIndex,
            speed: 450,
            spaceBetween: 16,
            grabCursor: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: $carousel.find('.reels-carousel__arrow--next')[0],
                prevEl: $carousel.find('.reels-carousel__arrow--prev')[0],
            },
            on: {
                init: function (swiper) {
                    playActiveVideo(swiper);
                },
                slideChangeTransitionEnd: function (swiper) {
                    playActiveVideo(swiper);
                },
            },
        });
    });

    $('.faq-accordion').each(function () {
        var $accordion = $(this);
        var $items = $accordion.find('.faq-accordion__item');

        $accordion.on('click', '.faq-accordion__trigger', function () {
            var $item = $(this).closest('.faq-accordion__item');
            var $panel = $item.find('.faq-accordion__panel');
            var isOpen = $item.hasClass('is-open');

            $items.removeClass('is-open');
            $items.find('.faq-accordion__trigger').attr('aria-expanded', 'false');
            $items.find('.faq-accordion__panel').prop('hidden', true);

            if (!isOpen) {
                $item.addClass('is-open');
                $(this).attr('aria-expanded', 'true');
                $panel.prop('hidden', false);
            }
        });
    });

    (function initExitIntentPopup() {
        var $popup = $('#exitIntentPopup');

        if (!$popup.length) {
            return;
        }

        var SESSION_KEY = 'devign_exit_intent_shown';
        var MOBILE_MQ = window.matchMedia('(max-width: 767px)');
        var MOBILE_PAGE_MIN_MS = 15000;
        var MOBILE_IDLE_MS = 10000;
        var hasTriggered = false;
        var idleTimer = null;
        var pageMinMet = false;

        function isSessionBlocked() {
            try {
                return sessionStorage.getItem(SESSION_KEY) === '1';
            } catch (error) {
                return false;
            }
        }

        function markSessionShown() {
            try {
                sessionStorage.setItem(SESSION_KEY, '1');
            } catch (error) {
                // Ignore storage failures and rely on in-memory guard.
            }
        }

        function openPopup() {
            if (hasTriggered || isSessionBlocked() || $popup.hasClass('is-open')) {
                return;
            }

            hasTriggered = true;
            markSessionShown();
            $popup.addClass('is-open').attr('aria-hidden', 'false');
            $('body').addClass('modal-active');
        }

        function closePopup() {
            $popup.removeClass('is-open').attr('aria-hidden', 'true');
            $('body').removeClass('modal-active');
        }

        function clearIdleTimer() {
            if (idleTimer) {
                window.clearTimeout(idleTimer);
                idleTimer = null;
            }
        }

        function scheduleMobileIdlePopup() {
            if (hasTriggered || !pageMinMet || !MOBILE_MQ.matches) {
                return;
            }

            clearIdleTimer();
            idleTimer = window.setTimeout(openPopup, MOBILE_IDLE_MS);
        }

        $popup.on('click', '[data-exit-intent-close]', function (e) {
            e.preventDefault();
            closePopup();
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && $popup.hasClass('is-open')) {
                closePopup();
            }
        });

        if (isSessionBlocked()) {
            return;
        }

        if (!MOBILE_MQ.matches) {
            $(document).on('mouseout', function (e) {
                if (hasTriggered || isSessionBlocked()) {
                    return;
                }

                if (!e.relatedTarget && e.clientY <= 0) {
                    openPopup();
                }
            });

            return;
        }

        window.setTimeout(function () {
            pageMinMet = true;
            scheduleMobileIdlePopup();
        }, MOBILE_PAGE_MIN_MS);

        $(window).on('scroll touchmove touchstart', function () {
            if (hasTriggered || !pageMinMet) {
                return;
            }

            scheduleMobileIdlePopup();
        });
    })();

    // Shop archive: filter dropdowns
    if ($('[data-shop-filters]').length) {
        $('[data-filter-trigger]').on('click', function (e) {
            e.stopPropagation();

            var $trigger = $(this);
            var $filter = $trigger.closest('.shop-toolbar__filter');
            var $panel = $filter.find('[data-filter-panel]');
            var isOpen = $trigger.attr('aria-expanded') === 'true';

            $('[data-filter-trigger]').not($trigger).attr('aria-expanded', 'false');
            $('[data-filter-panel]').not($panel).prop('hidden', true);

            $trigger.attr('aria-expanded', isOpen ? 'false' : 'true');
            $panel.prop('hidden', isOpen);
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('[data-shop-filters]').length) {
                $('[data-filter-trigger]').attr('aria-expanded', 'false');
                $('[data-filter-panel]').prop('hidden', true);
            }
        });
    }

});